import type { AssessmentTemplatesStore } from './interfaces'

export const actions = {
  setLoading (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['loading']): void {
    this.loading = payload
  },
  setTemplatesPaginatedData (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['templatesPaginatedData']): void {
    this.templatesPaginatedData = payload
  },
  setFilterSearch (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['filterSearch']): void {
    this.filterSearch = payload
  },
  setFilterType (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['filterType']): void {
    this.filterType = payload
  },
  setFilterDisciplineCode (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['filterDisciplineCode']): void {
    this.filterDisciplineCode = payload
  },
  setFilterGrade (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['filterGrade']): void {
    this.filterGrade = payload
  },
  setFilterStatus (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['filterStatus']): void {
    this.filterStatus = payload
  },
  setCurrentPage (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['perPage']): void {
    this.perPage = payload
  },
  setModalCreate (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['isModalCreate']): void {
    this.isModalCreate = payload
  },
  /** Opening (or closing) the delete modal also clears any previous 409 guard count, so the next row
   *  is never shown the previous row's blocked message. */
  setTemplateToDelete (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['templateToDelete']): void {
    this.templateToDelete = payload
    this.deleteBlockedAssessmentsCount = null
  },
  setTemplateToDuplicate (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['templateToDuplicate']): void {
    this.templateToDuplicate = payload
  },
  setDeleteBlockedAssessmentsCount (this: AssessmentTemplatesStore, payload: AssessmentTemplatesStore['deleteBlockedAssessmentsCount']): void {
    this.deleteBlockedAssessmentsCount = payload
  },
  resetFilters (this: AssessmentTemplatesStore): void {
    this.filterSearch = null
    this.filterType = null
    this.filterDisciplineCode = null
    this.filterGrade = null
    this.filterStatus = null
    this.currentPage = 1
  },
}
